// 封装api
// 引入封装好的axios
import axios from "axios";

import {AesEncrypt, getCommonRequestPrams, signature} from "../../utils/crypto";
// const baseUrl = 'https://testopenlink.smartcloudcon.com' 
const baseUrl = 'https://openlink.smartcloudcon.com' 
// 向各个接口分发axios
// export function loginForm(data) {
//   return request({
//     url: "",// 这个地址是去掉公共地址剩下的地址
//     method: "",// 请求方式 支持多种方式  get post put delete 等等
//     data,//发送请求要配置的参数 无参数的情况下也可以不写
//   })
// }
const baseUrl2 = 'https://gm-cn.smartcloudcon.com'

/**
 * 用户请求设备流媒体服务指令
 * @param data
 */
export function getMultiMediaAddr(data, serverDomain, appSecret, appKey) {
  const params = getCommonRequestPrams('GetMultiMediaAddr', appKey);
  data = JSON.stringify(data).replace(/[\r\n]/g, "");
  const iv = appSecret.substring(appSecret.length - 16);
  params.params = AesEncrypt(data, appSecret, iv);
  params.signature = signature(params, appSecret);
  // /consolelink
  const path = '/OpenLink/GetMultiMediaAddr';
  let url = baseUrl + path;
  return axios.post(url, params);
  // return ajax(url, {
  //   data: JSON.stringify(params),
  //   type: 'POST',
  //   contentType: 'multipart/form-data',
  //   processData: false,
  //   dataType: 'json',
  // })
}
export function setSysCommand(serverDomain,params){
  const path = '/consolelink/SysCommand';
  let url =  baseUrl+path;
  console.log(serverDomain,'url');
  return axios.post(url, params);
}
/**
 * 用户请求公共流媒体服务指令(webrtc)
 * @param data
 * @returns {*|boolean}
 */
// export function getPublicMediaAddr(serverDomain, data) {
//   // /consolelink
//   const path = '/OpenLink/GetPublicPlayAddr';
//   let url = serverDomain + path;
//   if (isDev()) {
//     url = `/api${  path}`;
//   }

//   return ajax(url, {
//     data: JSON.stringify(data),
//     type: 'POST',
//     contentType: 'multipart/form-data',
//     processData: false,
//     dataType: 'json',
//   })
// }

/**
 * ptz control
 * @param data
 * @returns {*|boolean}
 */
export function ptzControlCmd(data, serverDomain, appSecret, appKey) {
  const params = getCommonRequestPrams('PTZCmd', appKey);
  data = JSON.stringify(data).replace(/[\r\n]/g, "");
  const iv = appSecret.substring(appSecret.length - 16);
  params.params = AesEncrypt(data, appSecret, iv);
  params.signature = signature(params, appSecret);
  const path = '/OpenLink/PTZCmd';
  let url = path;
  url = baseUrl+path
  return axios.post(url, params);
  // return ajax(url, {
  //   data: JSON.stringify(params),
  //   type: 'POST',
  //   contentType: 'multipart/form-data',
  //   processData: false,
  //   dataType: 'json',
  // })
}

/**
 *
 * @param data
 * @param serverDomain
 * @param appSecret
 * @param appKey
 * @returns {*|boolean}
 */
export function openTalk(data, serverDomain, appSecret, appKey) {

  const params = getCommonRequestPrams('GetRevMultiMediaAddr', appKey);
  data = JSON.stringify(data).replace(/[\r\n]/g, "");
  const iv = appSecret.substring(appSecret.length - 16);
  params.params = AesEncrypt(data, appSecret, iv);
  params.signature = signature(params, appSecret);
  // /consolelink
  const path = '/OpenLink/GetRevMultiMediaAddr';
  let url = path;
  url = baseUrl + path
  return axios.post(url, params);
  // return ajax(url, {
  //   data: JSON.stringify(params),
  //   type: 'POST',
  //   contentType: 'multipart/form-data',
  //   processData: false,
  //   dataType: 'json',
  // })
}


// export function queryCloudFileDetail(data, serverDomain, appSecret, appKey){
//   const params = getCommonRequestPrams('QueryCloudFileDetail', appKey);
//   data = JSON.stringify(data).replace(/[\r\n]/g, "");
//   const iv = appSecret.substring(appSecret.length - 16);
//   params.params = AesEncrypt(data, appSecret, iv);
//   params.signature = signature(params, appSecret);
//   // /consolelink
//   const path = '/OpenLink/QueryCloudFileDetail';
//   let url = serverDomain + path;
//   if (isDev()) {
//     url = `/api${  path}`;
//   }
//   return ajax(url, {
//     data: JSON.stringify(params),
//     type: 'POST',
//     contentType: 'multipart/form-data',
//     processData: false,
//     dataType: 'json',
//   })
// }

// 获取nvr子设备列表
export function getSubDeviceList(serverDomain, data) {
  // /consolelink
  const path = 'hclink/device/nvr/getSubDeviceList';
  let url = path;
  url = serverDomain+path;

  return axios.post(url, data);
}

// 获取nvr子设备列表
export function getMultiMediaLocal(data) {
  // /consolelink
  const path = 'https://gm-cn.smartcloudcon.com/GMModule/V3/Media/GetMultiMediaRecordAddr';
  let url = path;
  // url = serverDomain+path;

  return axios.post(url, data);
}
